import ModalActionBar from './modal-action-bar';

export default ModalActionBar;
